var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sri d-inline-flex align-items-center" },
    [
      _vm.value > 0
        ? [
            _vm.short
              ? [
                  _c("span", {
                    staticClass:
                      "circle flex-center d-inline-flex bg-primary text-light mr-1",
                    class: _vm.sizeClass,
                    domProps: { textContent: _vm._s(_vm.value) },
                  }),
                  _c("span", {
                    domProps: { textContent: _vm._s("/ " + _vm.max) },
                  }),
                ]
              : _vm._l(_vm.bubbles, function (_, index) {
                  return _c("span", {
                    staticClass: "circle flex-center d-inline-flex",
                    class: _vm.itemClasses(index),
                    domProps: { textContent: _vm._s(index + 1) },
                  })
                }),
          ]
        : [_c("span", [_vm._v("-")])],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }